<div class="relative flex flex-col gap-1.5">
  @if (selectLabel) {
    <label
      [attr.for]="id"
      class="block truncate text-sm font-medium"
      [ngStyle]="{ color: labelColor }"
      >{{ selectLabel }}
      @if (description) {
        <span class="text-sm font-thin text-gray-500">
          ({{ description }})
        </span>
      }
      @if (isRequired) {
        <small class="relative bottom-1 text-sm text-feedback-warning-pure"
          >*</small
        >
      }
    </label>
  }

  <div class="liv-input-select-wrapper">
    <ng-select
      class="liv-input-select"
      [attr.id]="id"
      [searchable]="!!searchFn"
      [searchFn]="searchFn"
      [appendTo]="'body'"
      [popover]="true"
      [clearable]="showClearIcon"
      [multiple]="multiple"
      [groupBy]="groupBy"
      [selectableGroup]="selectableGroup"
      [selectableGroupAsModel]="selectableGroupAsModel"
      [items]="options"
      [class.liv-input-select--invalid]="isInvalid"
      [class.liv-input-select--sm]="selectProps.size === 'sm'"
      [class.liv-input-select--md]="selectProps.size === 'md'"
      [class.liv-input-select--lg]="selectProps.size === 'lg'"
      [class.invertedDropdown]="invertedDropdown"
      (change)="select($event)"
      [bindValue]="bindValue"
      [bindLabel]="bindLabel"
      [placeholder]="!hasValue ? placeholder : ''"
      [closeOnSelect]="!!searchFn || closeOnSelect"
      [(ngModel)]="value"
      [loading]="isLoading"
      [readonly]="readonly || isLoading"
      [disabled]="isDisabled"
      clearAllText="Limpar todos"
      notFoundText="Itens não encontrados"
      (open)="open()"
      (close)="close()"
    >
      <ng-template ng-loadingspinner-tmp>
        <span class="!mr-2 inline-block">
          <ui-spin-loader size="sm" />
        </span>
      </ng-template>

      @if (multiple && selectableGroup) {
        <ng-template
          ng-optgroup-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <div role="group" class="flex items-center">
            <input
              type="checkbox"
              [attr.id]="'item' + index"
              [ngModel]="item$.selected"
              [ngStyle]="{ 'accent-color': accentColor }"
              class="!mr-3 !h-4 !w-4 rounded border-neutral-hight-dark text-brand-primary-pure focus:ring-brand-primary-pure"
            />

            <label [attr.for]="name" class="multi-select-label">
              {{ item[groupBy] }}</label
            >
          </div>
        </ng-template>
      }

      @if (multiple) {
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <div
            role="group"
            class="flex items-center data-[isGroupedBy=true]:!pl-5"
            [attr.data-isGroupedBy]="selectableGroup"
          >
            <input
              type="checkbox"
              [attr.id]="'item' + index"
              [ngModel]="item$.selected"
              [ngStyle]="{ 'accent-color': accentColor }"
              class="focus:ring-brand-500 mr-3 h-4 w-4 rounded border-neutral-hight-light text-brand-primary-pure"
            />

            <label [attr.for]="name" class="multi-select-label">
              {{ item[bindLabel] }}</label
            >
          </div>
        </ng-template>
      }

      @if (!multiple) {
        <ng-template ng-option-tmp let-item="item" let-index="index">
          @if (finishedItemArray) {
            <div
              class="flex h-fit w-full flex-row items-center justify-between !gap-1"
              [ngClass]="
                finishedItemArray[index]
                  ? completedTextColor()
                  : 'text-neutral-low-dark'
              "
            >
              <span>{{ item[bindLabel] }}</span>
              @if (finishedItemArray[index]) {
                <span
                  class="flex w-full flex-row items-center justify-end !gap-1"
                >
                  <ng-icon
                    [name]="icon()"
                    size="18"
                    strokeWidth="2"
                    class="shrink-0"
                  />
                  {{ finishedItemLabel }}
                </span>
              }
            </div>
          } @else {
            <span class="text-neutral-low-dark">{{ item[bindLabel] }}</span>
          }
        </ng-template>
      }
    </ng-select>
  </div>

  @if (error) {
    <small
      class="relative flex items-start !gap-1.5 text-xs text-feedback-warning-pure"
    >
      {{ error }}</small
    >
  }
</div>
